/* eslint-disable no-underscore-dangle */

if (typeof window !== 'undefined' && window.__webpack_public_path__) {
  // @ts-expect-error ts-migrate(2304) FIXME: Cannot find name '__webpack_public_path__'.
  __webpack_public_path__ = window.__webpack_public_path__;
}

// We must treat this file as an export because isolateModules is set
export {};
/* eslint-enable no-underscore-dangle */
